import { useEffect, useState } from "react";

import client from "../../../client";

export interface ResourceState<T> {
  data: T | null;
  isLoading: boolean;
  hasError: boolean;
}

export const useDepositResource = <T>(uuid: string | undefined, path: string): ResourceState<T> => {
  const [state, setState] = useState<ResourceState<T>>({
    data: null,
    isLoading: Boolean(uuid),
    hasError: false,
  });

  useEffect(() => {
    if (!uuid) {
      return;
    }
    let active = true;
    setState({ data: null, isLoading: true, hasError: false });
    client
      .get(`/api/deposits/${uuid}/${path}/`)
      .then(response => {
        if (active) {
          setState({ data: response.data as T, isLoading: false, hasError: false });
        }
      })
      .catch(() => {
        if (active) {
          setState({ data: null, isLoading: false, hasError: true });
        }
      });
    return () => {
      active = false;
    };
  }, [uuid, path]);

  return state;
};
